import ShowTitle from "%/dynamic-component-editor/standard-pages/show-page/ShowTitle.vue";
import ShowNumSeasons from "%/dynamic-component-editor/standard-pages/show-page/ShowNumSeasons.vue";
import ShowNumEpisodes from "%/dynamic-component-editor/standard-pages/show-page/ShowNumEpisodes.vue";
import ShowCoverImage from "%/dynamic-component-editor/standard-pages/show-page/ShowCoverImage.vue";
import ShowDescription from "%/dynamic-component-editor/standard-pages/show-page/ShowDescription.vue";
import ShowGenre from "%/dynamic-component-editor/standard-pages/show-page/ShowGenre.vue";
import ShowSeasons from "%/dynamic-component-editor/standard-pages/show-page/ShowSeasons.vue";
import ShowEpisodes from "%/dynamic-component-editor/standard-pages/show-page/ShowEpisodes.vue";
import ShowType from "%/dynamic-component-editor/standard-components/show-card-small/ShowType.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyShow extends LegacyEntity {
  get elements() {
    return {
      ShowTitle,
      ShowType,
      ShowNumSeasons,
      ShowNumEpisodes,
      ShowCoverImage,
      ShowDescription,
      ShowGenre,
      ShowSeasons,
      ShowEpisodes,
    };
  }
}
